export enum WalletActionType {
	WITHDRAW = 'WITHDRAW',
	DEPOSIT = 'DEPOSIT',
}
